import { RangeType } from '../enums';

export const DateRangeType = {
  [RangeType.DAY]: {
    difference: 1,
    intervalSeconds: 3600 * 2, // 2 hours
  },
  [RangeType.WEEK]: {
    difference: 6,
    intervalSeconds: 3600 * 24, // 1 day
  },
  [RangeType.MONTH]: {
    difference: 29,
    intervalSeconds: 3600 * 24, // 1 day
  },
  [RangeType.YEAR]: {
    difference: 364,
    intervalSeconds: 3600 * 24, // 1 day
  },
};
